<dialogContent>
  <h3>{{ 'RuleHelpSection.HowToUseRuleEditor' | transloco }}</h3>
  <p>{{ 'RuleHelpSection.PurposeOfRules' | transloco }}</p>
  <p>{{ 'RuleHelpSection.UsageGuideForRuleEditor' | transloco }}</p>
  <p>{{ 'RuleHelpSection.PrettyfiedRuleDescription' | transloco }}</p>
  @for (helpSectionGroup of helpSectionGroups; track helpSectionGroup) {
    <div>
      @if (helpSectionGroup.title) {
        <h3>{{ helpSectionGroup.title | transloco }}</h3>
      }
      @for (helpSection of helpSectionGroup.sections; track helpSection) {
        <div class="fx-layout-row">
          <div class="fx-layout-column">
            <mat-label
              class="label-button fx-layout fx-layout-align-start-center"
              (click)="expandedSectionTitles[helpSection.title] = !expandedSectionTitles[helpSection.title]">
              <mat-icon>
                {{ expandedSectionTitles[helpSection.title] ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
              <span>{{ helpSection.title | transloco }}</span>
            </mat-label>
            <!-- RuleComponents - Section -->
            @if (helpSection.title === 'RuleComponents' && !!expandedSectionTitles['RuleComponents']) {
              <div class="fx-layout-row">
                <ul>
                  <li>
                    <strong>{{ 'RuleHelpSection.RuleComponents.ActivityDefinitionTitle' | transloco }}</strong>
                    <p>{{ 'RuleHelpSection.RuleComponents.ActivityDefinitionDescription' | transloco }}</p>
                    <br />
                  </li>
                  <li>
                    <strong>{{ 'RuleHelpSection.RuleComponents.ConditionDefinitionTitle' | transloco }}</strong>
                    <p>{{ 'RuleHelpSection.RuleComponents.ConditionDefinitionDescription' | transloco }}</p>
                    <p>
                      {{ 'Example' | transloco }}:
                      {{ 'RuleHelpSection.RuleComponents.ConditionDefinitionExample' | transloco }}
                    </p>
                    <p>
                      {{ 'CorrespondingFindingDefinition' | transloco }}:
                      {{ 'RuleHelpSection.RuleComponents.ConditionDefinitionCorrespondingFindingDefinition' | transloco }}
                    </p>
                    <br />
                  </li>
                  <li>
                    <strong>{{ 'RuleHelpSection.RuleComponents.FindingDefinitionTitle' | transloco }}</strong>
                    <p>{{ 'RuleHelpSection.RuleComponents.FindingDefinitionDescription' | transloco }}</p>
                    <p>{{ 'Example' | transloco }}: {{ 'RuleHelpSection.RuleComponents.FindingDefinitionExample' | transloco }}</p>
                    <p>{{ 'Rule' | transloco }}: {{ 'RuleHelpSection.RuleComponents.FindingDefinitionRule' | transloco }}</p>
                    <br />
                  </li>
                  <li>
                    <strong>{{ 'RuleHelpSection.RuleComponents.ObservationDefinitionTitle' | transloco }}</strong>
                    <p>{{ 'RuleHelpSection.RuleComponents.ObservationDefinitionDescription' | transloco }}</p>
                    <p>
                      {{ 'Examples' | transloco }}:
                      <br />
                      {{ 'RuleHelpSection.RuleComponents.ObservationDefinitionExample1' | transloco }}
                      <br />
                      {{ 'RuleHelpSection.RuleComponents.ObservationDefinitionExample2' | transloco }}
                    </p>
                  </li>
                </ul>
              </div>
            }
            <!-- Scores - Section -->
            @if (helpSection.title === 'Scores' && !!expandedSectionTitles['Scores']) {
              <div class="fx-layout-column scores-section">
                <p>{{ 'RuleHelpSection.Scores.Description' | transloco }}</p>
                {{ 'RuleHelpSection.Scores.ExampleOfAScore' | transloco }}:
                <br />
                <br />
                4 * [FD-TP53-Mutation-positive] +
                <br />
                2 * ([OD-beta-2-microglobulin] > 3.5) +
                <br />
                2 * [AD-IGHV-mutation-status] +
                <br />
                (patient.age > 65) +
                <br />
                1 * [FD-Binet-B]
              </div>
            }
            <!-- CompareOperators - Section -->
            @if (helpSection.title === 'CompareOperators' && !!expandedSectionTitles['CompareOperators']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>=</td>
                    <td>{{ 'RuleHelpSection.CompareOperators.Equals' | transloco }}</td>
                    <td>1 = 1</td>
                  </tr>
                  <tr>
                    <td>!=</td>
                    <td>{{ 'RuleHelpSection.CompareOperators.NotEquals' | transloco }}</td>
                    <td>1 != 2</td>
                  </tr>
                  <tr>
                    <td>></td>
                    <td>{{ 'RuleHelpSection.CompareOperators.GreaterThan' | transloco }}</td>
                    <td>2 > 1</td>
                  </tr>
                  <tr>
                    <td><</td>
                    <td>{{ 'RuleHelpSection.CompareOperators.LessThan' | transloco }}</td>
                    <td>1 < 2</td>
                  </tr>
                  <tr>
                    <td>>=</td>
                    <td>{{ 'RuleHelpSection.CompareOperators.GreaterThanEquals' | transloco }}</td>
                    <td>2 >= 2</td>
                  </tr>
                  <tr>
                    <td><=</td>
                    <td>{{ 'RuleHelpSection.CompareOperators.LessThanEquals' | transloco }}</td>
                    <td>2 <= 2</td>
                  </tr>
                </table>
              </div>
            }
            <!-- LogicalOperators - Section -->
            @if (helpSection.title === 'LogicalOperators' && !!expandedSectionTitles['LogicalOperators']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'RuleHelpSection.Description' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>and</td>
                    <td>
                      {{ 'RuleHelpSection.LogicalOperators.And.Description' | transloco }}
                    </td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.And.Syntax' | transloco }}</td>
                    <td>[FD-Acute-myeloid-leukemia] and [OD-RUNX1]</td>
                  </tr>
                  <tr>
                    <td>or</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Or.Description' | transloco }}</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Or.Syntax' | transloco }}</td>
                    <td>[FD-Rai-Stadium-III] or [FD-Rai-Stadium-IV]</td>
                  </tr>
                  <tr>
                    <td>xor</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Xor.Description' | transloco }}</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Xor.Syntax' | transloco }}</td>
                    <td>[FD-Rai-Stadium-III] xor [FD-Rai-Stadium-IV]</td>
                  </tr>
                  <tr>
                    <td>in</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.In.Description' | transloco }}</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.In.Syntax' | transloco }}</td>
                    <td>5 in range(3;5)</td>
                  </tr>
                  <tr>
                    <td>not</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Not.Description' | transloco }}</td>
                    <td>{{ 'RuleHelpSection.LogicalOperators.Not.Syntax' | transloco }}</td>
                    <td>not([FD-B-Symptoms])</td>
                  </tr>
                </table>
              </div>
            }
            <!-- Functions - Section -->
            @if (helpSection.title === 'Functions' && !!expandedSectionTitles['Functions']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>abs</td>
                    <td>{{ 'RuleHelpSection.Functions.AbsolutValue' | transloco }}</td>
                    <td>abs(-2)</td>
                  </tr>
                  <tr>
                    <td>max</td>
                    <td>{{ 'RuleHelpSection.Functions.Max' | transloco }}</td>
                    <td>max(1;2)</td>
                  </tr>
                  <tr>
                    <td>min</td>
                    <td>{{ 'RuleHelpSection.Functions.Min' | transloco }}</td>
                    <td>min(1;2)</td>
                  </tr>
                  <tr>
                    <td>sqrt</td>
                    <td>{{ 'RuleHelpSection.Functions.SquareRoot' | transloco }}</td>
                    <td>sqrt(4)</td>
                  </tr>
                  <tr>
                    <td>exp</td>
                    <td>{{ 'RuleHelpSection.Functions.Exponential' | transloco }}</td>
                    <td>exp(2;2)</td>
                  </tr>
                  <tr>
                    <td>log</td>
                    <td>{{ 'RuleHelpSection.Functions.Logarithm' | transloco }}</td>
                    <td>log(2)</td>
                  </tr>
                  <tr>
                    <td>list</td>
                    <td>{{ 'RuleHelpSection.Functions.List' | transloco }}</td>
                    <td>list('a';'b')</td>
                  </tr>
                  <tr>
                    <td>range</td>
                    <td>{{ 'RuleHelpSection.Functions.Range' | transloco }}</td>
                    <td>5 in range(3;5)</td>
                  </tr>
                  <tr>
                    <td>ago</td>
                    <td>{{ 'RuleHelpSection.Functions.PreviousValue' | transloco }}</td>
                    <td>[OD-tumor-size].ago() or [OD-tumor-size].ago(2wk) or [OD-tumor-size].ago([AD-therapy].start)</td>
                  </tr>
                  <tr>
                    <td>count</td>
                    <td>{{ 'RuleHelpSection.Functions.Count' | transloco }}</td>
                    <td>
                      2 < count([OD-lab-value]:value > 3 and effectiveDateTime < [AD-therapy].start and effectiveDateTime.hour in range(4;
                      12))
                    </td>
                  </tr>
                </table>
              </div>
            }
            <!-- TimeParameters - Section -->
            @if (helpSection.title === 'TimeParameters' && !!expandedSectionTitles['TimeParameters']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>now</td>
                    <td>{{ 'RuleHelpSection.TimeParameters.Now' | transloco }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>TimeSpan</td>
                    <td>
                      {{ 'RuleHelpSection.TimeParameters.TimeSpan' | transloco }}
                      <br />
                      <br />
                      a: {{ 'Year' | transloco }}
                      <br />
                      mo: {{ 'Month' | transloco }}
                      <br />
                      wk: {{ 'Week' | transloco }}
                      <br />
                      d: {{ 'Day' | transloco }}
                      <br />
                      h: {{ 'Hour' | transloco }}
                      <br />
                      min: {{ 'Minute' | transloco }}
                      <br />
                      s: {{ 'Second' | transloco }}
                      <br />
                    </td>
                    <td>2wk, 2a</td>
                  </tr>
                  <tr>
                    <td>cycle</td>
                    <td>{{ 'RuleHelpSection.TimeParameters.Cycle' | transloco }}</td>
                    <td>2c</td>
                  </tr>
                </table>
              </div>
            }
            <!-- PqtientVariables - Section -->
            @if (helpSection.title === 'PatientVariables' && !!expandedSectionTitles['PatientVariables']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>patient.age</td>
                    <td>{{ 'RuleHelpSection.PatientVariables.Age' | transloco }}</td>
                    <td>patient.age > 40</td>
                  </tr>
                  <tr>
                    <td>patient.deceased</td>
                    <td>{{ 'RuleHelpSection.PatientVariables.Deceased' | transloco }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>patient.gender</td>
                    <td>{{ 'RuleHelpSection.PatientVariables.Gender' | transloco }}</td>
                    <td></td>
                  </tr>
                </table>
              </div>
            }
            <!-- References - Section -->
            @if (helpSection.title === 'References' && !!expandedSectionTitles['References']) {
              <div class="fx-layout-row">
                <table>
                  <tr>
                    <th>{{ 'Operator' | transloco }}</th>
                    <th>{{ 'Usage' | transloco }}</th>
                    <th>{{ 'Example' | transloco }}</th>
                  </tr>
                  <tr>
                    <td>.end</td>
                    <td>{{ 'RuleHelpSection.References.End' | transloco }}</td>
                    <td>[AD-Test].end</td>
                  </tr>
                  <tr>
                    <td>.start</td>
                    <td>{{ 'RuleHelpSection.References.Start' | transloco }}</td>
                    <td>[AD-Test].start</td>
                  </tr>
                  <tr>
                    <td>.effective</td>
                    <td>{{ 'RuleHelpSection.References.Effective' | transloco }}</td>
                    <td>[AD-Test].effective</td>
                  </tr>
                  <tr>
                    <td>.ended</td>
                    <td>{{ 'RuleHelpSection.References.Ended' | transloco }}</td>
                    <td>[AD-Test].ended</td>
                  </tr>
                  <tr>
                    <td>.ineffective</td>
                    <td>{{ 'RuleHelpSection.References.Ineffective' | transloco }}</td>
                    <td>[AD-Test].ineffective</td>
                  </tr>
                  <tr>
                    <td>.intolerance</td>
                    <td>{{ 'RuleHelpSection.References.Intolerance' | transloco }}</td>
                    <td>[AD-Test].intolerance</td>
                  </tr>
                  <tr>
                    <td>.started</td>
                    <td>{{ 'RuleHelpSection.References.Started' | transloco }}</td>
                    <td>[AD-Test].started</td>
                  </tr>
                </table>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</dialogContent>
<dialogActions class="fx-layout fx-layout-align-end-center" fxLayout>
  <button ttButtonvariant="secondary"
    ><span>{{ 'Close' | transloco }}</span></button
  >
</dialogActions>
